import React, {createContext, useContext, useState} from 'react'
import type {ImportSourceType} from '../core/_requests'

/**
 * The Files panel browser publishes these so other chrome (the AI chat composer) can run the
 * same upload / external-import flow without duplicating the file inputs or ImportWizard.
 */
export interface FileImportActions {
  onUploadFile: () => void
  onUploadFolder: () => void
  onImportS3: (sourceType?: ImportSourceType) => void
}

const FileImportActionsContext = createContext<FileImportActions | null>(null)
const FileImportRegisterContext = createContext<(actions: FileImportActions | null) => void>(
  () => undefined
)

export const FileImportActionsProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [actions, setActions] = useState<FileImportActions | null>(null)
  return (
    <FileImportRegisterContext.Provider value={setActions}>
      <FileImportActionsContext.Provider value={actions}>{children}</FileImportActionsContext.Provider>
    </FileImportRegisterContext.Provider>
  )
}

/** Null when the Files panel is not mounted (no subscription) or still registering. */
export const useFileImportActions = (): FileImportActions | null => useContext(FileImportActionsContext)

/** No-op outside {@link FileImportActionsProvider} so FileTable tests need no extra wrap. */
export const useRegisterFileImportActions = (): ((actions: FileImportActions | null) => void) =>
  useContext(FileImportRegisterContext)

/** Test helper: inject actions without standing up FileTable. */
export const FileImportActionsContextForTests = FileImportActionsContext
